
export const BASEURLS = (path) => {
    return `https://backend.satkartar.org/assets/mis/${path}`;
}